module.exports = __webpack_public_path__ + "static/img/erweima.94b7e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.png
// module id = hMRt
// module chunks = 169